module.exports = __webpack_public_path__ + "static/img/header.a43726d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/header.png
// module id = K5Rs
// module chunks = 1